/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    d="M18.5 9c2.4853 0 4.5 2.0147 4.5 4.5 0 1.2069-.4766 2.3013-1.25 3.1094V21.5a.751.751 0 0 1-.4629.6934.75.75 0 0 1-.8174-.1631L18.5 20.0605l-1.9697 1.9698a.75.75 0 0 1-.8174.1631.751.751 0 0 1-.4629-.6934v-4.8906C14.4766 15.8013 14 14.7069 14 13.5c0-2.4853 2.0147-4.5 4.5-4.5m1.75 8.6465A4.49 4.49 0 0 1 18.5 18a4.49 4.49 0 0 1-1.75-.3535v2.043l1.2197-1.2198.0567-.0517a.7503.7503 0 0 1 1.0039.0517l1.2197 1.2198zM20.75 1c1.5186.0002 2.75 1.2313 2.75 2.75v5a.75.75 0 0 1-1.5 0v-5c0-.6902-.5598-1.2498-1.25-1.25h-18c-.6904 0-1.25.5596-1.25 1.25v12c0 .6904.5596 1.25 1.25 1.25h10.6504l.0762.0039c.3781.0385.6738.3578.6738.7461s-.2957.7076-.6738.7461l-.0762.0039H2.75C1.2312 18.5 0 17.2688 0 15.75v-12C0 2.2312 1.2312 1 2.75 1zm-9.8428 10.3486a.75.75 0 0 1 0 1.4922l-.0771.0039H5.1436a.7507.7507 0 0 1-.75-.75c0-.4141.3359-.7498.75-.75H10.83zm6.2032-5.8271c.3782.0383.6738.3577.6738.746a.7507.7507 0 0 1-.6738.7462l-.0762.0039H5.1436a.7506.7506 0 0 1-.75-.75c0-.4141.3359-.7498.75-.75h11.8906z"
  />,
  'MenuCertificateFilled'
);
